import React, { Fragment } from 'react';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';
import { TTransaction } from '@modules/transactions/types2';

import Row from './Row';

import style from './Table.scss';

const cn = bemCssModules(style, 'Table');
const ti = getTestId('Table');

const getDate = (timestamp: number, language?: string) => {
  const isCurrentYear = new Date().getFullYear() === new Date(timestamp).getFullYear();
  const year = isCurrentYear ? undefined : 'numeric';
  const options = { year, month: 'short', day: 'numeric' } as const;
  return new Intl.DateTimeFormat(language, options).format(timestamp);
};

export const Table: CustomFC = ({ className }) => {
  const [{ transactions, global }] = useStore();
  const { list } = transactions;
  const language = global.lang;

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      {Object.entries(list).map(([ts, data]) => (
        <Fragment key={ts}>
          <div className={cn('date', ['small'])}>{getDate(+ts, language)}</div>
          {Object.values(data as any).map(transaction => (
            <Row key={(transaction as TTransaction).id} transaction={transaction as TTransaction} />
          ))}
        </Fragment>
      ))}
    </div>
  );
};

export default Table;
